import { useEffect, useState } from 'react';
import ResqlyMark from '@/components/resqly/ResqlyMark';

export default function Splash({ onDone, duration = 2200 }) {
  const [fading, setFading] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), duration - 500);
    const t2 = setTimeout(() => onDone && onDone(), duration);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [duration, onDone]);
  return (
    <div className={`splash-screen ${fading ? 'fade-out' : ''}`}>
      <div className="splash-logo flex flex-col items-center">
        <ResqlyMark size={88} className="drop-shadow-[0_12px_32px_rgba(0,0,0,0.3)]" />
        <div className="mt-5 text-white font-bold text-3xl tracking-tight">Resqly</div>
        <div className="mt-2 text-blue-100/90 text-sm font-medium">Healthcare simplified.</div>
      </div>
    </div>
  );
}
